/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import React, { FC, useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import {
  Avatar,
  Box,
  CardMedia,
  Fade,
  Grid,
  ImageList,
  ImageListItem,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import AirplanemodeActiveOutlinedIcon from "@mui/icons-material/AirplanemodeActiveOutlined";
import SportsBasketballOutlinedIcon from "@mui/icons-material/SportsBasketballOutlined";
import MessageArea from "components/shared/messageArea/MessageArea";
import classes from "./style";
import Profil from "models/Profil";
import Genders from "models/Enums/Genders";
import searchService from "services/searchService";
import { getImageUrl } from "utils/imageUtils";

export interface ProfileDetailsProps {
  open: boolean;
  profile: Profil;
  handleClose: () => void;
}

const ProfilePreview: FC<ProfileDetailsProps> = ({
  handleClose,
  open,
  profile,
}: ProfileDetailsProps) => {

  const genderAndName = () => {
    const gender = profile.user.gender == Genders.Male ? 'Homme' : profile.user.gender == Genders.Female ? 'Femme' : undefined;
    return gender ? `${gender}, ${profile.user.age} ans` : `${profile.user.age} ans`;
  }

  const invite = async (e: String) => {
    if (e?.length == 0) {
      return;
    }

    await searchService.propose(profile.user.id, profile.from, profile.to, profile.country.id, e);
    handleClose();
  }

  const hasPersonalPictures = (profile.user.personalPictures?.length ?? 0) > 0;

  const getPersonalPictures = () => {
    const length = profile.user.personalPictures?.length ?? 0;

    switch (length) {
      case 1:
        return <ImageListItem key={'profil1'} cols={2} rows={2}>
            <img src={getImageUrl(profile.user.personalPictures[0])} width="100%" height="100%" 
          loading="lazy"/>
          </ImageListItem>;
      case 2:
        return <>
          <ImageListItem key={'profil1'} cols={1} rows={2}>
              <img src={getImageUrl(profile.user.personalPictures[0])} width="100%" height="100%" 
              loading="lazy"/>
          </ImageListItem>
          <ImageListItem key={'profil2'} cols={1} rows={2}>
            <img src={getImageUrl(profile.user.personalPictures[1])} width="100%" height="100%" 
              loading="lazy"/>
          </ImageListItem>
          </>;
      case 3:
        return <>
          <ImageListItem key={'profil1'} cols={2} rows={1}>
              <img src={getImageUrl(profile.user.personalPictures[0])} width="100%" height="100%" 
              loading="lazy"/>
          </ImageListItem>
          <ImageListItem key={'profil2'} cols={1} rows={1}>
            <img src={getImageUrl(profile.user.personalPictures[1])} width="100%" height="100%" 
              loading="lazy"/>
          </ImageListItem>
          <ImageListItem key={'profil3'} cols={1} rows={1}>
            <img src={getImageUrl(profile.user.personalPictures[2])} width="100%" height="100%" 
              loading="lazy"/>
          </ImageListItem>
          </>;
        default: return <></>;
    }
  }

  return (
    <Fade in={open}>
      <Box sx={classes.profilePreview}>
        <Box display="flex" justifyContent="end">
          <CloseOutlinedIcon color="primary" onClick={handleClose} />
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={hasPersonalPictures ? 6 : 12}>
          <CardMedia
                component="img" sx={{width: '80px', height: '80px'}}
                image={getImageUrl(profile.user.profilePicture)}
                alt={`${profile.user.lastName} ${profile.user.firstName}`}
              />
              <Typography component="div" variant="h5">
              {`${profile.user.lastName} ${profile.user.firstName}`}
              </Typography>
              <Typography component="div" variant="body1">
                {genderAndName()}
              </Typography>
              <Grid container spacing={0} alignItems="center">
                <Grid item xs={12} md={6}>
                  { profile.user.pastTravels?.length == 0 ? '' : 
                    <Box>
                      <ListItem>
                        <ListItemAvatar>
                          <Avatar>
                            <MapOutlinedIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="Destinations" />
                      </ListItem>
                      <Typography component="div" variant="body1">
                        { profile.user.pastTravels.join(', ') }
                      </Typography>
                    </Box>
                  }
                  { profile.user.favoriteTransports?.length == 0 ? '' : 
                    <Box>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar>
                          <AirplanemodeActiveOutlinedIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText primary="Moyens de transport" />
                    </ListItem>
                    <Typography component="div" variant="body1">
                    { profile.user.favoriteTransports.join(', ') }
                    </Typography>
                  </Box>
                  }

                  { profile.user.favoriteStayTypes?.length == 0 ? '' : 
                  <Box>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar>
                          <SportsBasketballOutlinedIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText primary="Ambiance" />
                    </ListItem>
                    <Typography component="div" variant="body1">
                    { profile.user.favoriteStayTypes.join(', ') }
                    </Typography>
                  </Box>
                  }
                </Grid>
                <Grid item md={6} xs={12}>
                  <Box>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar>
                          <MapOutlinedIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText primary="Description" />
                    </ListItem>
                    <Typography component="div" variant="body1">
                      { profile.user.description }
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
              <MessageArea
                withSubmitButton
                handleSubmit={(e: String) => invite(e)}
              />
          </Grid>
          { hasPersonalPictures && 
            <Grid item xs={6}>
              <ImageList variant="quilted" cols={2}>
                {
                  getPersonalPictures()
                }
              </ImageList>
            </Grid>
          }
        </Grid>
      </Box>
    </Fade>
  );
};

export default ProfilePreview;
